<template>
    <div class="pop_tab_container">
      <div class="pop_header_tab">
        <ul class="nav nav-pills">
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('deposit')">충전신청</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('withdraw')">환전신청</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('money')">머니내역</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('notice')">공지사항</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link">이벤트</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('qna')">1:1 문의</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="this.$root.ChangePopup('userinfo')">마이페이지</a>
            </li>
          </ul>
      </div>
    </div>
</template>

<script>
    export default {
        name: "pop_header",
        methods:{

        }
    };
</script>

<style>
.pop_tab_container{
    height: 50px;
    
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}
.pop_header_tab{
    background-color: #0d6efd;
    border-radius: 10px 10px 10px 10px / 10px 10px 10px 10px;
    height: 100%;
    width: 720px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
</style>